import { usePermissions, useTranslate } from "ra-core";
import { Link } from "react-router";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import {
  mobileMoreItems,
  mobileTabSubItems, // GAVION my-calls
  settingsLinks,
} from "./navItems";
import { DuplicatesCount } from "../dataQuality/DuplicatesCount"; // GAVION import duplicates
import { MeetingsCount } from "../meetings/MeetingsNavBadge"; // GAVION granola partners
import { RecruitingCount } from "../recruiting/RecruitingNavBadge"; // GAVION recruiting

export const MoreSheet = ({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
}) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  const settingsHeadingId = "more-sheet-settings";
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="rounded-t-xl">
        <SheetHeader>
          <SheetTitle>{translate("gavion.nav.more")}</SheetTitle>
        </SheetHeader>
        <ul className="grid gap-1 p-2">
          {/* GAVION my-calls: the tabs' sub-links (« Mes appels ») first */}
          {[
            ...mobileTabSubItems(),
            ...mobileMoreItems(permissions === "admin"),
          ].map((item) => (
            <li key={item.key}>
              <Link
                to={item.to}
                onClick={() => onOpenChange(false)}
                className="flex items-center gap-3 rounded-lg px-3 py-3 text-sm hover:bg-muted"
              >
                <item.icon className="size-5" aria-hidden="true" />
                {translate(item.labelKey)}
                {"badge" in item && item.badge === "meetings_unmatched" && (
                  <MeetingsCount />
                )}
                {"badge" in item && item.badge === "job_applications_new" && (
                  <RecruitingCount />
                )}
              </Link>
            </li>
          ))}
        </ul>
        {/* Batch 2 Paramètres pages: mobile has no user menu, so they live here. */}
        <h2
          id={settingsHeadingId}
          className="px-5 pt-2 text-xs font-bold uppercase text-muted-foreground"
        >
          {translate("gavion.nav.settings")}
        </h2>
        <ul aria-labelledby={settingsHeadingId} className="grid gap-1 p-2">
          {settingsLinks(permissions === "admin").map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                onClick={() => onOpenChange(false)}
                className="flex items-center gap-3 rounded-lg px-3 py-3 text-sm hover:bg-muted"
              >
                <link.icon className="size-5" aria-hidden="true" />
                {translate(link.labelKey)}
                {link.badge === "data_quality_duplicates" && (
                  <DuplicatesCount />
                )}
              </Link>
            </li>
          ))}
        </ul>
      </SheetContent>
    </Sheet>
  );
};
